import { CharacterAvatar } from '@/entities/user/components/character-avatar';
import { isEmptyString } from '@/shared/utils/string';
import { useEffect, useState } from 'react';

interface ProfileImageProps {
  src: string;
  name: string;
  className?: string;
}

export function ProfileImage({ src, name, className }: ProfileImageProps) {
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => {
    setHasImageError(false);
  }, [src]);

  if (isEmptyString(src) || hasImageError) {
    return <CharacterAvatar name={name} className={className} />;
  }

  return <img src={src} alt={name} className={className} onError={() => setHasImageError(true)} />;
}
